<div class="h-full rounded-md border border-steel-20">
  <rma-skeleton class="flex flex-col gap-y-6 p-3 md:p-6" [bones]="1" template="custom">
    <div class="heading mb-4 h-6! w-full"></div>
    <div class="flex gap-x-4">
      <div class="flex-1">
        <div class="text mb-2 h-6! w-10"></div>
        <div class="text h-4! w-full"></div>
      </div>
      <div class="flex-1">
        <div class="text mb-2 h-6! w-10"></div>
        <div class="text h-4! w-full"></div>
      </div>
    </div>
  </rma-skeleton>
</div>
